// Generated from Comment's `required_filter_groups` — do not edit.

import type {FilterDefinitionMapping} from '../../boot/hooks/useApi'
import type {Iri} from '../Api'

export type CommentCollectionFilterGroups
  = | {
    readonly route: Iri
    readonly routeArchived?: boolean | boolean[] | '*'
  }
  | {
    readonly routeSectorSpot: Iri | Iri[]
    readonly routeArchived?: boolean | boolean[] | '*'
  }
  | {
    readonly author: Iri | Iri[]
    readonly routeArchived?: boolean | boolean[] | '*'
  }

export const commentCollectionFilterMapping: FilterDefinitionMapping<CommentCollectionFilterGroups> = {
  route: 'route',
  routeArchived: 'route.archived',
  routeSectorSpot: 'route.sector.spot',
  author: 'author',
}

export type CommentCollectionSort = 'route.name' | 'author.name' | 'createdAt' | 'liked' | 'tickType'
